import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { retry, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ServiceCallUtilsService } from '../service-call-utils.service';

@Injectable({
  providedIn: 'root'
})
export class FrequentQuestionsService {

  constructor(private http: HttpClient, private serviceCallUtilsService: ServiceCallUtilsService) { }
  /**
   * Description: Método que llama el servicio web que obtiene las preguntas frecuentes
   * Autor: Steven Sterling
   * @param category indica la sección desde la cual se llama el componente
   * @return Listado de preguntas frecuentes
   */
  getFQSList(category) {
    return this.http.post(
      environment.apiUrl + '/FQSControllerRESTService/getFQSList',
      category,
      this.serviceCallUtilsService.getHttpHeaderOptions())
      .pipe(
        retry(environment.retryTimes),
        catchError(this.serviceCallUtilsService.handleError)
      )
  }
}
